import { installSingleClickDirective } from './installSingleClickDirective'
import { App } from 'vue'

export const installVueDirectives = (app: App) => {
  installSingleClickDirective(app)
}
